import type { IMotorcycleManualSearchSelection } from '@shared/types/IVehicleSelection';

import { GarageVehicle } from './types';

export const remove = (vehicle: GarageVehicle, vehicles: GarageVehicle[]) =>
  vehicles.filter((v) => v.vehicleId !== vehicle.vehicleId);

export const add = (vehicle: GarageVehicle, vehicles: GarageVehicle[]) =>
  remove(vehicle, vehicles).concat([vehicle]);

export const select = (vehicle: GarageVehicle, vehicles: GarageVehicle[]): GarageVehicle[] =>
  vehicles.map((v) =>
    v.vehicleId === vehicle.vehicleId ? { ...v, selected: true } : { ...v, selected: false },
  );

export const toVehicleManualSearchSelection = (
  selectedVehicle: GarageVehicle,
): IMotorcycleManualSearchSelection => {
  return {
    make: selectedVehicle.make ?? '',
    model: selectedVehicle.model ?? '',
    submodel: selectedVehicle.submodel ?? '',
    year: selectedVehicle.exactYear?.toString() ?? '',
  };
};

export const formatYear = (from: number | undefined, to: number | undefined) =>
  from === to ? from : `${from} – ${to ?? new Date().getFullYear()}`;

export const getFormattedTitleFull = (vehicle: GarageVehicle) =>
  `${formatYear(vehicle.yearFrom, vehicle.yearTo)} ${vehicle.make} ${vehicle.series}`.trim();

export const getFormattedTitleShort = (vehicle: GarageVehicle) =>
  `${vehicle.make} ${vehicle.series}`.trim();

// Use `series` as it returns better info than `model`, but remove extra noise
// e.g., "DR-Z 400 E (WVBF)" -> "DR-Z 400 E"
export const getFormattedTitleTiny = (vehicle: GarageVehicle) =>
  vehicle?.series?.replace(/\(.*\)/, '').trim() ?? '';
